import { parseAssessmentDate } from "./assessmentDateUtils";

export const DEFAULT_TEAM_CURRENCY_DAYS = 30;
export const DEFAULT_ACCOUNT_CURRENCY_DAYS = 45;
/** Currency follows the org cycle length (60 or 90 days). */
export const DEFAULT_CYCLE_CURRENCY_DAYS = 90;

/** @deprecated Use DEFAULT_TEAM_CURRENCY_DAYS */
export const DEFAULT_SELF_ASSESSMENT_CURRENCY_DAYS = DEFAULT_TEAM_CURRENCY_DAYS;

export const SELF_ASSESSMENT_CURRENCY_DAY_OPTIONS = [1, 15, 30, 45, 60];

export const resolveSelfAssessmentCurrencyDays = (
  value?: unknown,
  fallback: number = DEFAULT_TEAM_CURRENCY_DAYS
): number => {
  const n = Number(value);
  return Number.isFinite(n) && n > 0 ? n : fallback;
};

export const formatDaysAgo = (days: number): string =>
  days <= 0 ? "today" : days === 1 ? "1 day ago" : `${days} days ago`;

/** "Stale · 98 days ago" when the prior is older than the cycle length. */
export const buildStaleDaysLabel = (
  latest?: {
    input_label_stale?: boolean;
    input_days_since?: number | null;
  } | null
): string | null =>
  latest?.input_label_stale && latest.input_days_since != null
    ? `Stale · ${formatDaysAgo(latest.input_days_since)}`
    : null;

/** True when draft is strictly newer than the completed prior used for My cadence. */
export const isDraftNewerThanPrior = (
  draftUpdatedAt?: string | null,
  priorSubmittedAt?: string | null
): boolean => {
  if (!draftUpdatedAt) return false;
  if (!priorSubmittedAt) return true;
  const draft = parseAssessmentDate(draftUpdatedAt);
  const prior = parseAssessmentDate(priorSubmittedAt);
  if (!draft) return false;
  if (!prior) return true;
  return draft.getTime() > prior.getTime();
};

export const resolveTeamCurrencyDays = (value?: unknown): number =>
  resolveSelfAssessmentCurrencyDays(value, DEFAULT_TEAM_CURRENCY_DAYS);

export const resolveAccountCurrencyDays = (value?: unknown): number =>
  resolveSelfAssessmentCurrencyDays(value, DEFAULT_ACCOUNT_CURRENCY_DAYS);

/** For settings dropdown — snap to allowed option or default */
export const normalizeSelfAssessmentCurrencyOption = (
  value?: unknown,
  fallback: number = DEFAULT_TEAM_CURRENCY_DAYS
): number => {
  const n = Number(value);
  return SELF_ASSESSMENT_CURRENCY_DAY_OPTIONS.includes(n) ? n : fallback;
};

export const normalizeTeamCurrencyOption = (value?: unknown): number =>
  normalizeSelfAssessmentCurrencyOption(value, DEFAULT_TEAM_CURRENCY_DAYS);

export const normalizeAccountCurrencyOption = (value?: unknown): number =>
  normalizeSelfAssessmentCurrencyOption(value, DEFAULT_ACCOUNT_CURRENCY_DAYS);
